import axios from "axios";
import { API_URL } from "@/config/api.js";
import { withShioriAccessContext } from "@/api/shiori-access-context.js";

const isImageBlob = (value) =>
  value instanceof Blob &&
  value.size > 0 &&
  String(value.type || "").startsWith("image/");

export const resolveEmbeddedShioriImageUrl = (shiori) => {
  if (!shiori?.HAS_IMAGE) return "";

  const dataUri = String(shiori.IMAGE_DATA_URI || "");
  if (dataUri.startsWith("data:image/")) return dataUri;

  const guestImageUrl = String(shiori.IMAGE_URL || "");
  if (shiori.__guest && /^\/(?!\/)/.test(guestImageUrl)) {
    return guestImageUrl;
  }
  return "";
};

export const fetchAuthenticatedShioriImageUrl = async (
  shioriId,
  { timeout } = {},
) => {
  if (!shioriId) return "";
  const response = await axios.get(
    `${API_URL}/shiori/${shioriId}/image`,
    withShioriAccessContext(
      shioriId,
      {
        responseType: "blob",
        ...(timeout ? { timeout } : {}),
      },
      { recoverReadForbidden: true },
    ),
  );
  if (!isImageBlob(response.data)) return "";
  return URL.createObjectURL(response.data);
};

export const fetchSharedShioriImageUrl = async (
  shioriId,
  shareToken,
  { timeout } = {},
) => {
  if (!shioriId || !shareToken) return "";
  const response = await axios.get(`${API_URL}/shiori/${shioriId}/image`, {
    responseType: "blob",
    headers: { "X-Shiori-Share-Token": shareToken },
    ...(timeout ? { timeout } : {}),
  });
  if (!isImageBlob(response.data)) return "";
  return URL.createObjectURL(response.data);
};

export const revokeShioriImageUrl = (imageUrl) => {
  if (typeof imageUrl === "string" && imageUrl.startsWith("blob:")) {
    URL.revokeObjectURL(imageUrl);
  }
};
